import React from 'react';

const GooglePlayStoreLogo = ({ ...props }) => (
  <svg
    width="115"
    height="36"
    viewBox="0 0 115 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M111.406 35.9375H3.59375C1.61719 35.9375 0 34.3203 0 32.3438V3.59375C0 1.61719 1.61719 0 3.59375 0H111.406C113.383 0 115 1.61719 115 3.59375V32.3438C115 34.3203 113.383 35.9375 111.406 35.9375Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.80469 17.6094V8.17578C8.80469 7.63672 9.25391 7.1875 9.70312 7.1875C10.1523 7.1875 10.332 7.27734 10.6016 7.45703L27.9414 16.9805C28.3008 17.1602 28.4805 17.4297 28.4805 17.6992C28.4805 17.9688 28.3008 18.2383 27.9414 18.418L10.6016 27.9414C10.4219 28.0312 10.1523 28.2109 9.70312 28.2109C9.25391 28.2109 8.80469 27.7617 8.80469 27.2227V17.6094Z"
      fill="url(#paint0_linear_923_6914)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0352 17.6992L9.52344 7.1875C9.61328 7.1875 9.61328 7.1875 9.70312 7.1875C10.1523 7.1875 10.332 7.27734 10.6016 7.45703L23.3594 14.4648L20.0352 17.6992Z"
      fill="url(#paint1_linear_923_6914)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.2695 20.8437L20.0352 17.6094L23.3594 14.2852L27.9414 16.8008C28.3008 16.9805 28.4805 17.25 28.4805 17.5195C28.4805 17.7891 28.3008 18.0586 27.9414 18.2383L23.2695 20.8437Z"
      fill="url(#paint2_linear_923_6914)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.61328 28.0313L20.0352 17.6094L23.2695 20.8438L10.6016 27.7617C10.332 27.9414 10.1523 28.0313 9.61328 28.0313C9.70313 28.0313 9.70313 28.0313 9.61328 28.0313Z"
      fill="url(#paint3_linear_923_6914)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.8786 30.457C63.4294 30.0977 63.07 29.4688 62.8903 29.1094L64.3278 28.4805C64.4177 28.6602 64.5974 28.9297 64.7771 29.1992C65.1364 29.5586 65.6755 29.918 66.2146 29.918C66.7536 29.918 67.3825 29.6484 67.7419 29.1992C68.0114 28.75 68.1911 28.3008 68.1911 27.6719V27.1328C67.113 28.4805 64.8669 28.3008 63.6091 26.8633C62.2614 25.4258 62.2614 23 63.6091 21.5625C64.9567 20.2148 66.9333 20.0352 68.1012 21.293V20.6641H69.6286V27.4023C69.6286 29.1094 68.9997 30.0977 68.1911 30.7266C67.652 31.1758 66.8435 31.3555 66.1247 31.3555C65.3161 31.2656 64.5075 30.9961 63.8786 30.457ZM101.523 30.8164L103.05 27.2227L100.355 21.0234H101.883L103.769 25.4258L105.656 21.0234H107.183L103.05 30.8164H101.523ZM94.2458 27.4023C93.7966 26.9531 93.6169 26.3242 93.6169 25.6953C93.6169 25.1562 93.7966 24.6172 94.1559 24.2578C94.7848 23.6289 95.6833 23.3594 96.6716 23.3594C97.3005 23.3594 97.8395 23.4492 98.2888 23.7188C98.2888 22.6406 97.3903 22.1914 96.6716 22.1914C96.0427 22.1914 95.4138 22.5508 95.1442 23.1797L93.7966 22.6406C94.0661 22.0117 94.7849 20.8438 96.5817 20.8438C97.4802 20.8438 98.3786 21.1133 98.9177 21.7422C99.4567 22.3711 99.6364 23.0898 99.6364 24.0781V27.8516H98.1091V27.2227C97.9294 27.4922 97.57 27.6719 97.3005 27.8516C96.9411 28.0313 96.4919 28.1211 96.0427 28.1211C95.5036 28.0312 94.695 27.8516 94.2458 27.4023ZM46.3591 24.168C46.3591 22.3711 47.7067 20.3945 50.1325 20.3945C52.4685 20.3945 53.9059 22.3711 53.9059 24.168C53.9059 25.9648 52.5583 27.9414 50.1325 27.9414C47.7067 27.9414 46.3591 25.9648 46.3591 24.168ZM54.445 24.168C54.445 22.3711 55.7927 20.3945 58.2185 20.3945C60.5544 20.3945 61.9919 22.3711 61.9919 24.168C61.9919 25.9648 60.6442 27.9414 58.2185 27.9414C55.8825 27.9414 54.445 25.9648 54.445 24.168ZM36.2067 26.1445C33.9606 23.8984 34.0505 20.2148 36.2966 17.8789C37.4645 16.7109 38.902 16.1719 40.4294 16.1719C41.8669 16.1719 43.3044 16.7109 44.3825 17.7891L43.3044 18.957C41.6872 17.3398 39.0817 17.4297 37.5544 19.0469C35.9372 20.7539 35.9372 23.3594 37.5544 25.0664C39.1716 26.7734 41.8669 26.8633 43.4841 25.1563C44.0231 24.6172 44.2028 23.8984 44.2927 23.1797H40.5192V21.5625H45.82C45.9099 21.9219 45.9099 22.3711 45.9099 22.8203C45.9099 24.168 45.3708 25.5156 44.4724 26.4141C43.4841 27.4023 42.0466 27.9414 40.6091 27.9414C38.9919 27.8516 37.3747 27.3125 36.2067 26.1445ZM74.2106 26.7734C72.863 25.3359 72.863 22.9102 74.2106 21.3828C75.5583 19.9453 77.8044 19.9453 79.0622 21.3828C79.5114 21.832 79.781 22.4609 80.0505 23.0898L75.1091 25.1563C75.3786 25.7852 76.0075 26.3242 76.906 26.3242C77.7146 26.3242 78.2536 26.0547 78.7927 25.2461L80.1403 26.1445C79.9606 26.3242 79.781 26.5039 79.6911 26.6836C78.1638 28.2109 75.5583 28.2109 74.2106 26.7734ZM83.5544 27.8516V17.8789H86.7888C88.6755 17.8789 90.2028 19.2266 90.2028 20.8438C90.2028 22.4609 88.8552 23.8086 87.1481 23.8086H85.1716V27.7617H83.5544V27.8516ZM91.1013 27.8516V17.8789H92.6286V27.8516H91.1013ZM70.7966 27.6719V16.5313H72.4138V27.6719H70.7966ZM98.1989 24.8867C97.8395 24.6172 97.3005 24.5273 96.7614 24.5273C95.6833 24.5273 95.0544 25.0664 95.0544 25.6953C95.0544 26.3242 95.6833 26.6836 96.3122 26.6836C97.2106 26.6836 98.1989 25.9648 98.1989 24.8867ZM52.1989 24.168C52.1989 23.0898 51.4802 21.9219 50.1325 21.9219C48.7849 21.9219 48.0661 23.0898 48.0661 24.168C48.0661 25.2461 48.7849 26.4141 50.1325 26.4141C51.3903 26.4141 52.1989 25.2461 52.1989 24.168ZM60.2849 24.168C60.2849 23.0898 59.5661 21.9219 58.2185 21.9219C56.8708 21.9219 56.152 23.0898 56.152 24.168C56.152 25.2461 56.8708 26.4141 58.2185 26.4141C59.5661 26.4141 60.2849 25.2461 60.2849 24.168ZM68.2809 24.7969C68.2809 24.707 68.281 24.6172 68.3708 24.5273C68.3708 24.4375 68.3708 24.2578 68.3708 24.168C68.3708 24.0781 68.3708 23.8984 68.3708 23.8086V23.7188C68.3708 23.6289 68.2809 23.4492 68.2809 23.3594C68.0114 22.4609 67.2028 21.832 66.3942 21.832C65.3161 21.832 64.4177 22.9102 64.4177 24.0781C64.4177 25.3359 65.3161 26.3242 66.4841 26.3242C67.2028 26.4141 67.9216 25.7852 68.2809 24.7969ZM74.8395 23.9883L78.1638 22.5508C77.8044 21.9219 77.2653 21.7422 76.8161 21.7422C75.4684 21.832 74.6598 23.2695 74.8395 23.9883ZM88.5856 20.9336C88.5856 20.0352 87.8669 19.4062 86.8786 19.4062H85.0817V22.5508H86.9684C87.8669 22.5508 88.5856 21.832 88.5856 20.9336Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M102.692 29.02H102.602V28.9297H102.692H102.602V29.02H102.692Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M102.871 29.02C102.871 28.9297 102.871 28.9297 102.871 29.02C102.781 28.9297 102.781 28.9297 102.871 29.02C102.781 29.02 102.781 29.02 102.871 29.02ZM102.871 28.9297C102.871 29.02 102.871 29.02 102.871 28.9297C102.871 29.02 102.781 29.02 102.871 28.9297C102.781 28.9297 102.871 28.9297 102.871 28.9297Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M102.961 28.9297H102.871H102.961V29.02V28.9297Z"
      fill="white"
    />
    <path
      d="M34.9492 9.07422C34.9492 7.45703 36.1172 6.46875 37.5547 6.46875C38.543 6.46875 39.1719 6.91797 39.6211 7.54687L38.9024 7.99609C38.6328 7.63672 38.1836 7.36719 37.5547 7.36719C36.5664 7.36719 35.8477 8.08594 35.8477 9.16406C35.8477 10.2422 36.5664 10.9609 37.5547 10.9609C38.0938 10.9609 38.543 10.6914 38.7227 10.5117V9.70312H37.2852V8.89453H39.7109V10.7812C39.2617 11.3203 38.543 11.6797 37.6445 11.6797C36.1172 11.6797 34.9492 10.6016 34.9492 9.07422Z"
      fill="white"
    />
    <path
      d="M40.7891 11.5898V6.55859H44.2031V7.36719H41.5977V8.625H44.1133V9.43359H41.5977V10.8711H44.2031V11.6797L40.7891 11.5898Z"
      fill="white"
    />
    <path
      d="M46.7187 11.5898V7.36719H45.1914V6.55859H49.1445V7.36719H47.6172V11.5898H46.7187Z"
      fill="white"
    />
    <path d="M52.1992 11.5898V6.55859H53.0977V11.5898H52.1992Z" fill="white" />
    <path
      d="M55.5234 11.5898V7.36719H53.9961V6.55859H57.9492V7.36719H56.4219V11.5898H55.5234Z"
      fill="white"
    />
    <path
      d="M60.8242 9.07422C60.8242 7.54687 61.9024 6.46875 63.4297 6.46875C64.957 6.46875 66.0352 7.54687 66.0352 9.07422C66.0352 10.6016 64.957 11.6797 63.4297 11.6797C61.9024 11.6797 60.8242 10.5117 60.8242 9.07422ZM65.0469 9.07422C65.0469 7.99609 64.418 7.27734 63.3398 7.27734C62.3516 7.27734 61.6328 8.08594 61.6328 9.07422C61.6328 10.1523 62.2617 10.8711 63.3398 10.8711C64.418 10.8711 65.0469 10.0625 65.0469 9.07422Z"
      fill="white"
    />
    <path
      d="M70.5273 11.5898L67.9219 7.99609V11.5898H67.0234V6.55859H67.9219L70.5273 10.0625V6.55859H71.4258V11.5898H70.5273Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_923_6914"
        x1="14.6152"
        y1="5.90597"
        x2="19.6449"
        y2="26.5619"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006884" />
        <stop offset="1" stopColor="#8AD1D0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_923_6914"
        x1="8.48188"
        y1="8.84404"
        x2="22.1884"
        y2="16.2539"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#24BBB6" />
        <stop offset="1" stopColor="#DBE692" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_923_6914"
        x1="24.2528"
        y1="21.2212"
        x2="24.2528"
        y2="14.08"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCC072" />
        <stop offset="1" stopColor="#F58A5B" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_923_6914"
        x1="11.1359"
        y1="29.8902"
        x2="21.9636"
        y2="18.8707"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#712B8F" />
        <stop offset="1" stopColor="#EA1D27" />
      </linearGradient>
    </defs>
  </svg>
);

export default GooglePlayStoreLogo;
